import Vuex from 'vuex'

import Metric from '@/models/metric'
import METRIC_KEYS from '@/models/METRIC_KEYS'

export default {

    props: {
        /**
         * @returns {?Metric|VueProp}
         */
        co2Metric: {
            type: Metric,
            default: null,
        },
        /**
         * @returns {?Metric|VueProp}
         */
        fuelBillMetric: {
            type: Metric,
            default: null,
        },
        /**
         * @returns {?Metric|VueProp}
         */
        sapScoreMetric: {
            type: Metric,
            default: null,
        },
        /**
         * @returns {?Metric|VueProp}
         */
        useState: {
            type: Boolean,
            default: true,
        },
    },

    computed: {

        ...Vuex.mapState({
            /**
             * @param {VuexState} stateStore
             * @returns {Metric}
             */
            co2State: stateStore => Metric
                .fromData(stateStore.metrics.data.find(m => m.key === METRIC_KEYS.carbonSaving)),

            /**
             * @param {VuexState} stateStore
             * @returns {Metric}
             */
            fuelBillState: stateStore => Metric
                .fromData(stateStore.metrics.data.find(m => m.key === METRIC_KEYS.fuelBill)),

            /**
             * @param {VuexState} stateStore
             * @returns {Metric}
             */
            sapScoreState: stateStore => Metric
                .fromData(stateStore.metrics.data.find(m => m.key === METRIC_KEYS.sapScore)),
        }),

        /**
         * @returns {Metric}
         */
        co2() {
            return this.useState ? this.co2State : this.co2Metric
        },

        /**
         * @returns {Metric}
         */
        fuelBill() {
            return this.useState ? this.fuelBillState : this.fuelBillMetric
        },

        /**
         * @returns {boolean}
         */
        showSapMetric() {
            return this.$scheme.showSapMetrics
        },

        /**
         * @returns {Metric}
         */
        sapScore() {
            return this.useState ? this.sapScoreState : this.sapScoreMetric
        },
    },
}
